import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import Buefy from "buefy";
import VueObserveVisibility from "vue-observe-visibility";
import VueAnime from "vue-animejs";
import VueAnalytics from "vue-analytics";
import "./assets/scss/app.scss";

Vue.use(VueAnalytics, {
  id: "UA-148336070-1"
});

Vue.use(Buefy);
Vue.use(VueObserveVisibility);
Vue.use(VueAnime);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
